// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/AliveNet.proto" (syntax proto3)
// tslint:disable
import { UserInput } from "./Interaction";
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Notification } from "./Interaction";
import { Intent } from "./Interaction";
import { Any } from "../../google/protobuf/any";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf enum SurfaceInfo.DeviceType
 */
export var SurfaceInfo_DeviceType;
(function (SurfaceInfo_DeviceType) {
    /**
     * @generated from protobuf enum value: UNKNOWN_DEVICE_TYPE = 0;
     */
    SurfaceInfo_DeviceType[SurfaceInfo_DeviceType["UNKNOWN_DEVICE_TYPE"] = 0] = "UNKNOWN_DEVICE_TYPE";
    /**
     * @generated from protobuf enum value: PHONE = 1;
     */
    SurfaceInfo_DeviceType[SurfaceInfo_DeviceType["PHONE"] = 1] = "PHONE";
    /**
     * @generated from protobuf enum value: TABLET = 2;
     */
    SurfaceInfo_DeviceType[SurfaceInfo_DeviceType["TABLET"] = 2] = "TABLET";
    /**
     * @generated from protobuf enum value: DESKTOP = 3;
     */
    SurfaceInfo_DeviceType[SurfaceInfo_DeviceType["DESKTOP"] = 3] = "DESKTOP";
})(SurfaceInfo_DeviceType || (SurfaceInfo_DeviceType = {}));
/**
 * @generated from protobuf enum SurfaceInfo.AppEnvironment
 */
export var SurfaceInfo_AppEnvironment;
(function (SurfaceInfo_AppEnvironment) {
    /**
     * @generated from protobuf enum value: UNKNOWN_APP_ENVIRONMENT = 0;
     */
    SurfaceInfo_AppEnvironment[SurfaceInfo_AppEnvironment["UNKNOWN_APP_ENVIRONMENT"] = 0] = "UNKNOWN_APP_ENVIRONMENT";
    /**
     * @generated from protobuf enum value: NATIVE = 1;
     */
    SurfaceInfo_AppEnvironment[SurfaceInfo_AppEnvironment["NATIVE"] = 1] = "NATIVE";
    /**
     * @generated from protobuf enum value: BROWSER = 2;
     */
    SurfaceInfo_AppEnvironment[SurfaceInfo_AppEnvironment["BROWSER"] = 2] = "BROWSER";
})(SurfaceInfo_AppEnvironment || (SurfaceInfo_AppEnvironment = {}));
/**
 * @generated from protobuf enum SurfaceInfo.OwnerType
 */
export var SurfaceInfo_OwnerType;
(function (SurfaceInfo_OwnerType) {
    /**
     * @generated from protobuf enum value: UNKNOWN_OWNER_TYPE = 0;
     */
    SurfaceInfo_OwnerType[SurfaceInfo_OwnerType["UNKNOWN_OWNER_TYPE"] = 0] = "UNKNOWN_OWNER_TYPE";
    /**
     * @generated from protobuf enum value: USER = 1;
     */
    SurfaceInfo_OwnerType[SurfaceInfo_OwnerType["USER"] = 1] = "USER";
    /**
     * @generated from protobuf enum value: GROUP = 2;
     */
    SurfaceInfo_OwnerType[SurfaceInfo_OwnerType["GROUP"] = 2] = "GROUP";
})(SurfaceInfo_OwnerType || (SurfaceInfo_OwnerType = {}));
/**
 * @generated from protobuf enum Membership.Role
 */
export var Membership_Role;
(function (Membership_Role) {
    /**
     * @generated from protobuf enum value: UNKNOWN_ROLE = 0;
     */
    Membership_Role[Membership_Role["UNKNOWN_ROLE"] = 0] = "UNKNOWN_ROLE";
    /**
     * @generated from protobuf enum value: ADMIN = 1;
     */
    Membership_Role[Membership_Role["ADMIN"] = 1] = "ADMIN";
    /**
     * @generated from protobuf enum value: MEMBER = 2;
     */
    Membership_Role[Membership_Role["MEMBER"] = 2] = "MEMBER";
    /**
     * @generated from protobuf enum value: GUEST = 3;
     */
    Membership_Role[Membership_Role["GUEST"] = 3] = "GUEST";
})(Membership_Role || (Membership_Role = {}));
/**
 * @generated from protobuf enum AliveNetResponse.ServerStatus
 */
export var AliveNetResponse_ServerStatus;
(function (AliveNetResponse_ServerStatus) {
    /**
     * @generated from protobuf enum value: UnknownServerStatus = 0;
     */
    AliveNetResponse_ServerStatus[AliveNetResponse_ServerStatus["UnknownServerStatus"] = 0] = "UnknownServerStatus";
    /**
     * @generated from protobuf enum value: Ok = 1;
     */
    AliveNetResponse_ServerStatus[AliveNetResponse_ServerStatus["Ok"] = 1] = "Ok";
    /**
     * @generated from protobuf enum value: NoSurfaceStream = 2;
     */
    AliveNetResponse_ServerStatus[AliveNetResponse_ServerStatus["NoSurfaceStream"] = 2] = "NoSurfaceStream";
    /**
     * @generated from protobuf enum value: Uninitialized = 3;
     */
    AliveNetResponse_ServerStatus[AliveNetResponse_ServerStatus["Uninitialized"] = 3] = "Uninitialized";
    /**
     * @generated from protobuf enum value: UnknownSurface = 4;
     */
    AliveNetResponse_ServerStatus[AliveNetResponse_ServerStatus["UnknownSurface"] = 4] = "UnknownSurface";
})(AliveNetResponse_ServerStatus || (AliveNetResponse_ServerStatus = {}));
/**
 * Actually a oneof but avoiding it for now because of TS compiler issues that would need to
 * be resolved. Only the field relevant to the specified message type should be populated.
 *
 * @generated from protobuf enum AliveNetMessage.Type
 */
export var AliveNetMessage_Type;
(function (AliveNetMessage_Type) {
    /**
     * @generated from protobuf enum value: Unknown = 0;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["Unknown"] = 0] = "Unknown";
    /**
     * @generated from protobuf enum value: Heartbeat = 1;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["Heartbeat"] = 1] = "Heartbeat";
    /**
     * @generated from protobuf enum value: Engagement = 2;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["Engagement"] = 2] = "Engagement";
    /**
     * @generated from protobuf enum value: Priorities = 3;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["Priorities"] = 3] = "Priorities";
    /**
     * @generated from protobuf enum value: Executions = 4;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["Executions"] = 4] = "Executions";
    /**
     * @generated from protobuf enum value: Firing = 5;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["Firing"] = 5] = "Firing";
    /**
     * @generated from protobuf enum value: Intents = 6;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["Intents"] = 6] = "Intents";
    /**
     * @generated from protobuf enum value: Notification = 7;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["Notification"] = 7] = "Notification";
    /**
     * @generated from protobuf enum value: Muted = 8;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["Muted"] = 8] = "Muted";
    /**
     * @generated from protobuf enum value: TextToSpeech = 9;
     */
    AliveNetMessage_Type[AliveNetMessage_Type["TextToSpeech"] = 9] = "TextToSpeech";
})(AliveNetMessage_Type || (AliveNetMessage_Type = {}));
/**
 * @generated from protobuf enum ExecutionData.EventType
 */
export var ExecutionData_EventType;
(function (ExecutionData_EventType) {
    /**
     * @generated from protobuf enum value: Unknown = 0;
     */
    ExecutionData_EventType[ExecutionData_EventType["Unknown"] = 0] = "Unknown";
    /**
     * @generated from protobuf enum value: Error = 1;
     */
    ExecutionData_EventType[ExecutionData_EventType["Error"] = 1] = "Error";
    /**
     * Server started up and loaded markings from DB / set initial markings
     *
     * @generated from protobuf enum value: ServerInit = 2;
     */
    ExecutionData_EventType[ExecutionData_EventType["ServerInit"] = 2] = "ServerInit";
    /**
     * Server transition firing
     *
     * @generated from protobuf enum value: ServerFiring = 3;
     */
    ExecutionData_EventType[ExecutionData_EventType["ServerFiring"] = 3] = "ServerFiring";
    /**
     * Client reported a firing that the server accepted
     *
     * @generated from protobuf enum value: ClientFiringAccepted = 4;
     */
    ExecutionData_EventType[ExecutionData_EventType["ClientFiringAccepted"] = 4] = "ClientFiringAccepted";
    /**
     * Client reported a firing that the server rejected
     *
     * @generated from protobuf enum value: ClientFiringRejected = 5;
     */
    ExecutionData_EventType[ExecutionData_EventType["ClientFiringRejected"] = 5] = "ClientFiringRejected";
    /**
     * Server reinitialized some markings due to invalid state detected
     *
     * @generated from protobuf enum value: ServerReset = 6;
     */
    ExecutionData_EventType[ExecutionData_EventType["ServerReset"] = 6] = "ServerReset";
    /**
     * A controller was manually forced to reinitialize (e.g. using a script)
     *
     * @generated from protobuf enum value: ManualReset = 7;
     */
    ExecutionData_EventType[ExecutionData_EventType["ManualReset"] = 7] = "ManualReset";
})(ExecutionData_EventType || (ExecutionData_EventType = {}));
/**
 * @generated from protobuf enum UserEngagement
 */
export var UserEngagement;
(function (UserEngagement) {
    /**
     * @generated from protobuf enum value: Unknown = 0;
     */
    UserEngagement[UserEngagement["Unknown"] = 0] = "Unknown";
    /**
     * @generated from protobuf enum value: Absent = 1;
     */
    UserEngagement[UserEngagement["Absent"] = 1] = "Absent";
    /**
     * @generated from protobuf enum value: Present = 2;
     */
    UserEngagement[UserEngagement["Present"] = 2] = "Present";
    /**
     * Implies present
     *
     * @generated from protobuf enum value: Engaged = 3;
     */
    UserEngagement[UserEngagement["Engaged"] = 3] = "Engaged";
})(UserEngagement || (UserEngagement = {}));
// @generated message type with reflection information, may provide speed optimized methods
class UserInfo$Type extends MessageType {
    constructor() {
        super("UserInfo", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "agent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "photo_URL", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "phone_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_developer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message UserInfo
 */
export const UserInfo = new UserInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentInfo$Type extends MessageType {
    constructor() {
        super("AgentInfo", [
            { no: 1, name: "agent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "birthdate", kind: "message", T: () => Timestamp },
            { no: 5, name: "color_scheme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "tts_params", kind: "message", T: () => TextToSpeechParams },
            { no: 7, name: "model_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "accessory", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "accessory_policy", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message AgentInfo
 */
export const AgentInfo = new AgentInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SurfaceInfo$Type extends MessageType {
    constructor() {
        super("SurfaceInfo", [
            { no: 1, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_type", kind: "enum", T: () => ["SurfaceInfo.DeviceType", SurfaceInfo_DeviceType] },
            { no: 3, name: "app_environment", kind: "enum", T: () => ["SurfaceInfo.AppEnvironment", SurfaceInfo_AppEnvironment] },
            { no: 4, name: "owner_type", kind: "enum", T: () => ["SurfaceInfo.OwnerType", SurfaceInfo_OwnerType] },
            { no: 5, name: "owner_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "fcm_device_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "onboarding_complete", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message SurfaceInfo
 */
export const SurfaceInfo = new SurfaceInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GroupInfo$Type extends MessageType {
    constructor() {
        super("GroupInfo", [
            { no: 1, name: "group_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "creation_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "surface_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "user_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "invited_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message GroupInfo
 */
export const GroupInfo = new GroupInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Membership$Type extends MessageType {
    constructor() {
        super("Membership", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "roles", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "enum", T: () => ["Membership.Role", Membership_Role] } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Membership
 */
export const Membership = new Membership$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailIndexedUser$Type extends MessageType {
    constructor() {
        super("EmailIndexedUser", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "invited_group_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message EmailIndexedUser
 */
export const EmailIndexedUser = new EmailIndexedUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextToSpeechParams$Type extends MessageType {
    constructor() {
        super("TextToSpeechParams", [
            { no: 1, name: "voice_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rate", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "pitch", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "volume", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message TextToSpeechParams
 */
export const TextToSpeechParams = new TextToSpeechParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextToSpeechMessage$Type extends MessageType {
    constructor() {
        super("TextToSpeechMessage", [
            { no: 1, name: "message_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tts_params", kind: "message", T: () => TextToSpeechParams },
            { no: 4, name: "speaker_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message TextToSpeechMessage
 */
export const TextToSpeechMessage = new TextToSpeechMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AliveNetResponse$Type extends MessageType {
    constructor() {
        super("AliveNetResponse", [
            { no: 1, name: "server_status", kind: "enum", T: () => ["AliveNetResponse.ServerStatus", AliveNetResponse_ServerStatus] },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message AliveNetResponse
 */
export const AliveNetResponse = new AliveNetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PetriNetState$Type extends MessageType {
    constructor() {
        super("PetriNetState", [
            { no: 1, name: "marking", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => PlaceData } },
            { no: 2, name: "petri_net_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message PetriNetState
 */
export const PetriNetState = new PetriNetState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlaceData$Type extends MessageType {
    constructor() {
        super("PlaceData", [
            { no: 1, name: "tokens", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message PlaceData
 */
export const PlaceData = new PlaceData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Execution$Type extends MessageType {
    constructor() {
        super("Execution", [
            { no: 1, name: "controller_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "agent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "controller_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "petri_net_state", kind: "message", T: () => PetriNetState },
            { no: 5, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 6, name: "origin_surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "last_changed_surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Execution
 */
export const Execution = new Execution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Firing$Type extends MessageType {
    constructor() {
        super("Firing", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "transition_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "controller_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "agent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "prev_executions", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Execution } },
            { no: 7, name: "next_executions", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Execution } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Firing
 */
export const Firing = new Firing$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Reset$Type extends MessageType {
    constructor() {
        super("Reset", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "controller_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "agent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "affected_controller_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "prev_executions", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Execution } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Reset
 */
export const Reset = new Reset$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SurfaceConnection$Type extends MessageType {
    constructor() {
        super("SurfaceConnection", [
            { no: 1, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 4, name: "engagement", kind: "enum", T: () => ["UserEngagement", UserEngagement] },
            { no: 5, name: "summary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_muted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message SurfaceConnection
 */
export const SurfaceConnection = new SurfaceConnection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AliveNetMessage$Type extends MessageType {
    constructor() {
        super("AliveNetMessage", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "message_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "message_type", kind: "enum", T: () => ["AliveNetMessage.Type", AliveNetMessage_Type] },
            { no: 4, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "engagement", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "enum", T: () => ["UserEngagement", UserEngagement] } },
            { no: 6, name: "priorities", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 7, name: "executions", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Execution } },
            { no: 8, name: "firing", kind: "message", T: () => Firing },
            { no: 9, name: "intents", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Intent },
            { no: 10, name: "notification", kind: "message", T: () => Notification },
            { no: 11, name: "surface_connections", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SurfaceConnection },
            { no: 12, name: "is_muted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "tts_message", kind: "message", T: () => TextToSpeechMessage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message AliveNetMessage
 */
export const AliveNetMessage = new AliveNetMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExecutionData$Type extends MessageType {
    constructor() {
        super("ExecutionData", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "agent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "event_type", kind: "enum", T: () => ["ExecutionData.EventType", ExecutionData_EventType] },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "executions", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Execution } },
            { no: 7, name: "firing", kind: "message", T: () => Firing },
            { no: 8, name: "reset", kind: "message", T: () => Reset }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message ExecutionData
 */
export const ExecutionData = new ExecutionData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PriorityData$Type extends MessageType {
    constructor() {
        super("PriorityData", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "curr_surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "prev_surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "engagement", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "enum", T: () => ["UserEngagement", UserEngagement] } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message PriorityData
 */
export const PriorityData = new PriorityData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetExecutionRequest$Type extends MessageType {
    constructor() {
        super("ResetExecutionRequest", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "controller_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message ResetExecutionRequest
 */
export const ResetExecutionRequest = new ResetExecutionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetExecutionResponse$Type extends MessageType {
    constructor() {
        super("ResetExecutionResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message ResetExecutionResponse
 */
export const ResetExecutionResponse = new ResetExecutionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetMarkingRequest$Type extends MessageType {
    constructor() {
        super("SetMarkingRequest", [
            { no: 1, name: "agent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "message", T: () => PetriNetState }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message SetMarkingRequest
 */
export const SetMarkingRequest = new SetMarkingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetMarkingResponse$Type extends MessageType {
    constructor() {
        super("SetMarkingResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message SetMarkingResponse
 */
export const SetMarkingResponse = new SetMarkingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntentRequest$Type extends MessageType {
    constructor() {
        super("IntentRequest", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "request_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "intent", kind: "message", T: () => Intent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message IntentRequest
 */
export const IntentRequest = new IntentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntentResponse$Type extends MessageType {
    constructor() {
        super("IntentResponse", [
            { no: 1, name: "accepted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message IntentResponse
 */
export const IntentResponse = new IntentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExecutionHistoryRequest$Type extends MessageType {
    constructor() {
        super("ExecutionHistoryRequest", [
            { no: 1, name: "agent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "time_start", kind: "message", T: () => Timestamp },
            { no: 3, name: "time_end", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message ExecutionHistoryRequest
 */
export const ExecutionHistoryRequest = new ExecutionHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExecutionHistoryResponse$Type extends MessageType {
    constructor() {
        super("ExecutionHistoryResponse", [
            { no: 1, name: "executions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExecutionData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message ExecutionHistoryResponse
 */
export const ExecutionHistoryResponse = new ExecutionHistoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAccountRequest$Type extends MessageType {
    constructor() {
        super("UserAccountRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message UserAccountRequest
 */
export const UserAccountRequest = new UserAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAccountResponse$Type extends MessageType {
    constructor() {
        super("UserAccountResponse", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_info", kind: "message", T: () => UserInfo },
            { no: 3, name: "agent_info", kind: "message", T: () => AgentInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message UserAccountResponse
 */
export const UserAccountResponse = new UserAccountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnnounceRequest$Type extends MessageType {
    constructor() {
        super("AnnounceRequest", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "request_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "agent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message AnnounceRequest
 */
export const AnnounceRequest = new AnnounceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnnounceResponse$Type extends MessageType {
    constructor() {
        super("AnnounceResponse", [
            { no: 1, name: "accepted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message AnnounceResponse
 */
export const AnnounceResponse = new AnnounceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignedAnnounceRequest$Type extends MessageType {
    constructor() {
        super("AssignedAnnounceRequest", [
            { no: 1, name: "announce_request", kind: "message", T: () => AnnounceRequest },
            { no: 2, name: "assigned_surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message AssignedAnnounceRequest
 */
export const AssignedAnnounceRequest = new AssignedAnnounceRequest$Type();
/**
 * @generated ServiceType for protobuf service AliveNetService
 */
export const AliveNetService = new ServiceType("AliveNetService", [
    { name: "CheckServerStatus", options: {}, I: Empty, O: AliveNetResponse },
    { name: "ReportStatus", options: {}, I: AliveNetMessage, O: AliveNetResponse },
    { name: "Connect", serverStreaming: true, options: {}, I: SurfaceInfo, O: AliveNetMessage },
    { name: "SendIntent", options: {}, I: IntentRequest, O: IntentResponse },
    { name: "SendUserInput", options: {}, I: UserInput, O: IntentResponse },
    { name: "ResetExecution", options: {}, I: ResetExecutionRequest, O: ResetExecutionResponse },
    { name: "SetMarking", options: {}, I: SetMarkingRequest, O: SetMarkingResponse },
    { name: "GetExecutionHistory", options: {}, I: ExecutionHistoryRequest, O: ExecutionHistoryResponse },
    { name: "GetUserAccountInfo", options: {}, I: UserAccountRequest, O: UserAccountResponse },
    { name: "Announce", options: {}, I: AnnounceRequest, O: AnnounceResponse }
]);
